import React from 'react'
import ProjectContainer from '../components/containers/ProjectContainer'
import OnGoingContainer from '../components/containers/OnGoingContainer'

function ProjectsSection() {
  return (
    <section id="projects">
        <ProjectContainer/>
        <OnGoingContainer/>
    </section>
  )
}

export default ProjectsSection